import * as React from 'react';
import { createElement } from 'react';
import { Input, Icon, Dialog, Table as OriginalTable, Step, Select, Field } from '@alifd/next';
import columnsMap from './columns-map';
import { nanoid } from 'nanoid';
import { toPairs } from 'lodash';
const SerachTable = (props, ref) => {
    const { arrayEditFormField, mode, childFormChildren, onChange, ...restProps } = props;
    const [visible, setVisible] = React.useState(false);
    const [currentStep, setCurrentStep] = React.useState(0);
    const [dataSource, setDataSource] = React.useState([]);
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
    const tableField = Field.useField({
        parseName: true,
    });
    const onClick = () => {
        setVisible(true);
    };
    const handleOk = () => {
        const data = tableField.getValue('mapDataSource')?.filter((item) => !!item.field);
        const dataObj = {};
        data.forEach((item) => {
            const { value, field } = item;
            dataObj[field] = value;
        });
        arrayEditFormField.setValues(dataObj);
        setVisible(false);
    };
    const handleCancel = () => {
        setVisible(false);
    };
    const onClickStep = (currentStep) => {
        setCurrentStep(currentStep);
    };
    const onRowChange = (selectedRowKeys, records) => {
        setSelectedRowKeys(selectedRowKeys);
        setSelectedRows(records);
        setCurrentStep(1);
        setMapDataSource(records);
    };
    const rowSelection = {
        mode: 'single',
        onChange: onRowChange,
        selectedRowKeys,
    };
    React.useEffect(() => {
        if (mode) {
            setDataSource([
                { name: '1', number: 1 },
                { name: '2', number: 2 },
            ]);
        }
    }, [mode]);
    const fixedDataSource = React.useMemo(() => {
        return dataSource.map((item) => ({ ...item, uid: item.uid ?? nanoid() }));
    }, [dataSource]);
    const setMapDataSource = (records) => {
        const data = toPairs(records?.[0])
            ?.map((item) => {
            const [key, value] = item;
            return {
                key,
                value,
                desc: columnsMap[mode]?.find((m) => m.dataIndex === key)?.title,
            };
        })
            ?.filter((r) => r.key !== 'uid');
        tableField.setValue('mapDataSource', data);
    };
    const FieldItem = React.useCallback(({ value, index, record }) => {
        return (createElement(Select, { style: { width: '100%' }, ...tableField.init(`mapDataSource.${index}.field`) }, React.Children.map(childFormChildren, (child) => {
            const { props = {} } = child;
            const { formItemProps: { name, label, primaryKey } = {} } = props;
            return (createElement(Select.Option, { key: primaryKey, value: name }, `${label}(${name})`));
        })));
    }, [childFormChildren, tableField]);
    const mapDataSource = tableField.getValue('mapDataSource');
    return (createElement("div", null,
        createElement(Input, { ref: ref, innerAfter: createElement(Icon, { type: "search", size: "xs", onClick: onClick, style: { margin: 4, cursor: 'pointer' } }), style: { width: '100%' }, ...restProps }),
        createElement(Dialog, { v2: true, title: "", visible: visible, onOk: handleOk, onCancel: handleCancel, width: 1000, okProps: {
                disabled: currentStep === 0,
            }, closeMode: ['close', 'esc', 'mask'], onClose: handleCancel },
            createElement(Step, { current: currentStep, animation: true },
                createElement(Step.Item, { title: "\u9009\u62E9\u6570\u636E", onClick: onClickStep }),
                createElement(Step.Item, { title: "\u8868\u5355\u8D4B\u503C", onClick: onClickStep, disabled: selectedRows.length === 0 })),
            createElement("div", { className: "steps-content", style: { textAlign: 'center', marginTop: 20 } }, currentStep === 0 ? (createElement(OriginalTable.StickyLock, { dataSource: fixedDataSource, primaryKey: 'uid', rowSelection: rowSelection, size: 'small', fixedHeader: true, isZebra: true, crossline: true, maxBodyHeight: 224 }, columnsMap[mode]?.map(({ title, dataIndex }) => {
                return createElement(OriginalTable.Column, { title: title, dataIndex: dataIndex });
            }))) : (createElement(OriginalTable.StickyLock, { dataSource: mapDataSource, size: 'small', fixedHeader: true, isZebra: true, crossline: true, maxBodyHeight: 224 },
                createElement(OriginalTable.Column, { title: "\u952E\u540D", dataIndex: "key" }),
                createElement(OriginalTable.Column, { title: "\u952E\u503C", dataIndex: "value" }),
                createElement(OriginalTable.Column, { title: "\u63CF\u8FF0", dataIndex: "desc" }),
                createElement(OriginalTable.Column, { title: "\u8868\u5355\u9879", dataIndex: "field", cell: createElement(FieldItem, null) })))))));
};
const SerachTableRef = React.forwardRef(SerachTable);
export default SerachTableRef;
